export const COLUMN_WIDTHS = {
  operation: 68,
  taskId: 100,
  sprintId: 106,
  epicId: 150,
  assignee: 54,
  statusId: 125,
  TaskLabels: 160,
  startDate: 125,
  deadline: 125,
  priority: 126,
  estimate: 125,
  blocking: 160,
  blockedBy: 160,
  space: 40,
  subitems: 100,
} as const;

export type ColumnDataIndex = keyof typeof COLUMN_WIDTHS;

